import { CategoryService } from '../services/categories'

/**
 * Initialize default categories for the application
 * This function can be called from the admin panel to set up categories
 */
export async function initializeCategories(): Promise<{ success: boolean; message: string }> {
  try {
    await CategoryService.initializeDefaultCategories()
    return {
      success: true,
      message: 'デフォルトカテゴリーが正常に初期化されました。'
    }
  } catch (error) {
    console.error('Failed to initialize categories:', error)
    return {
      success: false,
      message: error instanceof Error ? error.message : 'カテゴリーの初期化に失敗しました。'
    }
  }
}